import { devauthzHeader } from 'apprise-core/auth'
import { claimAuthError } from 'apprise-frontend-core/client/authclaim'
import { ErrorInterceptor, RequestInterceptor } from 'apprise-frontend-core/client/config'
import { useEnv } from 'apprise-frontend-core/env'
import { useLoginConfig } from 'apprise-frontend-iam/login/context'
import { useLogin } from 'apprise-frontend-iam/login/logged'

// puts logged user in authz header for services in development that run out of cluster, so won't get it from the gateway.
export const useDevAuthInterceptor = (): RequestInterceptor => {

    const login = useLogin()

    return req => {

        const logged = login.logged()

        if (logged)
            req.headers = Object.assign({}, req.headers, { [devauthzHeader]: JSON.stringify(logged) })


    }

}


export const useLoginErrorInterceptor = (): ErrorInterceptor => {

    const config = useLoginConfig()
    const login = useLogin()
    const env = useEnv()

    return error => {

        const status = error.response?.status
        const authFailure = status === 401 || status === 403

        if (!authFailure)
            return

        const alreadyLogged = !!login.logged()

        // 1. guests landing on a public page: ignore, the loader logs a guest.
        // legacy backends report the missing identity as a 403, newer ones as 401 or a guest directly.
        if (config.mode == 'guest-allowed' && !alreadyLogged) {
            claimAuthError(error)
            return
        }

        // 2. out-of-cluster dev loads: redirect silently, the navigation is the login flow itself.
        const silent = !alreadyLogged && env.name == 'development'

        // 3. anything else (walled bootstrap, expired sessions): warn, then redirect to login.
        claimAuthError(error)

        login.logout({ askConsent: !silent, useAuth: true })

    }
}